import React, { ReactElement, ReactNode } from "react";
import { ActionIcon, Flex, Title, Button } from "@mantine/core";
import styles from "./MobileModalLayout.module.scss";
import { CLOSE_ICON_URL } from "../../constants";

interface MobileModalLayoutProps {
  title: string;
  onClose: () => void;
  onApply?: () => void;
  onClear?: () => void;
  children: ReactNode;
  applyLabel?: string;
  clearLabel?: string;
}

export function MobileModalLayout({
  title,
  onClose,
  onApply,
  onClear,
  children,
  applyLabel = "Apply",
  clearLabel = "Clear all",
}: MobileModalLayoutProps): ReactElement | null {
  return (
    <div className={styles.mobileFilter}>
      <Flex
        className={styles.txContainer}
        direction="column"
        h="100%"
        pos="relative"
        align="center"
      >
        {/* Close button */}
        <ActionIcon
          className={styles.closeIconWrapper}
          variant="subtle"
          onClick={onClose}
        >
          <img src={CLOSE_ICON_URL} alt="close icon" />
        </ActionIcon>

        {/* Content */}
        <Flex
          direction="column"
          p={30}
          h="90vh"
          justify="space-around"
          gap={40}
          w="100%"
        >
          <Title
            order={2}
            opacity={0.8}
            textWrap="balance"
            mt={20}
            mb={10}
            className={styles.title}
          >
            {title}
          </Title>

          {children}

          {/* Buttons */}
          {(onApply || onClear) && (
            <Flex
              direction="column"
              gap={14}
              mt="auto"
              style={{ width: "100%", padding: "0 10px" }}
            >
              {onClear && (
                <Button
                  variant="light"
                  color="gray"
                  fullWidth
                  onClick={onClear}
                >
                  {clearLabel}
                </Button>
              )}
              {onApply && (
                <Button
                  className={styles.confirmBtn}
                  fullWidth
                  onClick={onApply}
                >
                  {applyLabel}
                </Button>
              )}
            </Flex>
          )}
        </Flex>
      </Flex>
    </div>
  );
}
